import { render, staticRenderFns } from "./ColumnSubscriptions.vue?vue&type=template&id=47b50c2d&scoped=true&"
import script from "./ColumnSubscriptions.vue?vue&type=script&lang=js&"
export * from "./ColumnSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSubscriptions.vue?vue&type=style&index=0&id=47b50c2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b50c2d",
  null
  
)

export default component.exports